import React from 'react';
import './About.css';

const About = () => {
    return (
    <>
       <div className="aboutme-header">
           About Me
       </div>
       <div className="aboutme--body">
           My name is Rohit Raut and i am a front end developer with 2 years of experience.
           I guess you are here because you want to know a bit about me.huh? I'm not all that good at talking about myself,
           I have completed my B.E in Electronics and Telecommunication and the irony is now i m working in IT Industry.
           But you will never know what you will love until you get into that, For me now I am very much interested in Front end web development and i will stick to my passion :)  

       </div>
    </>
    )
}

export default About;